import { NarrativeTemplate } from './templates'

export const assetTemplates: NarrativeTemplate[] = [
  // High anomaly score with category
  {
    id: 'asset-high-anomaly-categorized',
    category: 'asset',
    condition: (data) => Number(data.anomalyScore) > 0.7 && Boolean(data.anomalyCategory),
    priority: 100,
    template: `{assetId} is showing a {anomalyCategory} pattern with {priority} priority.

Current Status:
• Anomaly Score: {anomalyScoreFormatted}
• Health Score: {healthScoreFormatted}
• Estimated Time to Failure: {timeToFailure}

Top Contributing Factors:
{topFeaturesFormatted}

Recommendation: Immediate inspection recommended. This pattern has historically indicated component degradation requiring intervention.`
  },

  // High anomaly score without category
  {
    id: 'asset-high-anomaly',
    category: 'asset',
    condition: (data) => Number(data.anomalyScore) > 0.7,
    priority: 90,
    template: `{assetId} requires attention - Anomaly score at {anomalyScoreFormatted}.

Analysis:
• Current health: {healthScoreFormatted}
• Estimated time to critical: {timeToFailure}
• Priority level: {priority}

Top Contributing Factors:
{topFeaturesFormatted}

Action Required: Investigate sensor readings and schedule preventive maintenance.`
  },

  // Moderate anomaly
  {
    id: 'asset-moderate-anomaly',
    category: 'asset',
    condition: (data) => Number(data.anomalyScore) > 0.4 && Number(data.anomalyScore) <= 0.7,
    priority: 70,
    template: `{assetId} showing elevated anomaly indicators at {anomalyScoreFormatted}.

Current Assessment:
• Health Score: {healthScoreFormatted}
• Priority: {priority}
• Pattern: {anomalyCategory}

Contributing Factors:
{topFeaturesFormatted}

Recommendation: Monitor closely over the next 24-48 hours. Consider scheduling inspection during next maintenance window.`
  },

  // Failure time warning
  {
    id: 'asset-failure-imminent',
    category: 'asset',
    condition: (data) => Number(data.failureTimeHours) < 48 && Number(data.failureTimeHours) > 0,
    priority: 110,
    template: `URGENT: {assetId} predicted to reach critical state {timeToFailure}.

Immediate Action Required:
• Current anomaly score: {anomalyScoreFormatted}
• Pattern detected: {anomalyCategory}
• Failure probability: HIGH

Key Indicators:
{topFeaturesFormatted}

Recommendation: Schedule immediate inspection or take asset offline for preventive maintenance to avoid unplanned downtime.`
  },

  // Healthy asset
  {
    id: 'asset-healthy',
    category: 'asset',
    condition: (data) => Number(data.anomalyScore) <= 0.4,
    priority: 40,
    template: `{assetId} is operating normally.

Status Summary:
• Health Score: {healthScoreFormatted}
• Anomaly Score: {anomalyScoreFormatted} (within normal range)
• No concerning patterns detected

All monitored parameters are within expected operating ranges. Continue standard monitoring.`
  },

  // Default
  {
    id: 'asset-default',
    category: 'asset',
    priority: 10,
    template: `{assetId} Status: {healthScoreFormatted} health, {anomalyScoreFormatted} anomaly score.

Current readings show {priority} priority level. Continue monitoring for changes.`
  }
]
